/* global axios */
import ApiClient from './ApiClient';

// Task 5 (credenciais por caixa): a credencial pertence a UMA inbox
// (bank_credentials.inbox_id) — todo método agora exige `inboxId` e o manda
// pro backend (query no GET/DELETE, corpo no POST/PATCH), que escopa e
// autoriza por lá (admin OU membro daquela inbox). Sem inboxId o backend
// responde 422 antes de tocar em qualquer linha.
//
// NOTA: este arquivo não estava neste overlay antes desta task — rodava a
// partir da imagem base, seguindo o mesmo padrão do CLAUDE.md ("copie o
// original de dentro da imagem para o mesmo caminho em webchat/files/ e edite
// ali"). Reconstruído a partir de
// `bank-settings/tokenfield/files/app/javascript/dashboard/api/bankSettings.js`
// (último overlay legado desta área) + a mudança de inboxId desta task.
class BankSettingsAPI extends ApiClient {
  constructor() {
    super('bank_settings', { accountScoped: true });
  }

  get(inboxId) {
    return axios.get(this.url, { params: { inbox_id: inboxId } });
  }

  show(id, inboxId) {
    return axios.get(`${this.url}/${id}`, { params: { inbox_id: inboxId } });
  }

  create(inboxId, data) {
    return axios.post(this.url, { ...data, inbox_id: inboxId });
  }

  update(id, inboxId, data) {
    return axios.patch(`${this.url}/${id}`, { ...data, inbox_id: inboxId });
  }

  delete(id, inboxId) {
    return axios.delete(`${this.url}/${id}`, { params: { inbox_id: inboxId } });
  }

  // Gera o token do banco agora (manual)
  refreshToken(id, inboxId) {
    return axios.post(`${this.url}/${id}/refresh_token`, { inbox_id: inboxId });
  }
}

// Chaves de API que os sistemas externos usam pra ler o token.
//
// Correção B (2026-08-12, fix do leak do Kairo): a chave pertence a UMA
// inbox (bank_api_keys.inbox_id) — igual à BankSettingsAPI acima, todo
// método agora exige `inboxId` e o manda pro backend (query no GET/DELETE,
// corpo no POST), que escopa e autoriza por lá (admin OU membro daquela
// inbox). Antes era `accountScoped: true` sem inboxId: as chaves eram
// GLOBAIS da conta — a caixa de qualquer cliente enxergava (e podia gerar)
// as mesmas chaves da caixa do Kairo.
class BankApiKeysClient extends ApiClient {
  constructor() {
    super('bank_api_keys', { accountScoped: true });
  }

  get(inboxId) {
    return axios.get(this.url, { params: { inbox_id: inboxId } });
  }

  create(inboxId, data) {
    return axios.post(this.url, { ...data, inbox_id: inboxId });
  }

  delete(id, inboxId) {
    return axios.delete(`${this.url}/${id}`, { params: { inbox_id: inboxId } });
  }
}

export const BankApiKeysAPI = new BankApiKeysClient();
export default new BankSettingsAPI();
